import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-M2 — TOURBILLON. Le professeur de l'anticipation.
 *
 *  Il s'ancre et déroule des anneaux dont chaque projectile COURBE du même sens.
 *  La figure radiale devient une spirale qui tourne — des bras de balles qui
 *  s'enroulent au lieu de filer droit.
 *
 *  ── Ce qu'il enseigne ──
 *  À viser le FUTUR d'un projectile, pas son présent. Devant un tir droit, on
 *  s'écarte de là où la balle est. Devant une balle qui courbe, ce réflexe
 *  précis vous jette dessous : au moment où vous atteignez la case « vide », la
 *  balle y a tourné. Il faut lire l'arc et se placer là où il ne PASSERA pas.
 *  C'est la même bascule mentale que le Mortier impose sur l'espace, mais
 *  appliquée au temps.
 *
 *  ── Pourquoi c'est LISIBLE, donc juste ──
 *  La courbe est constante et indépendante du joueur : ce n'est pas une
 *  poursuite, c'est une géométrie. Elle ne réagit pas à vos feintes, elle se
 *  répète — donc elle s'apprend. Un projectile qui courberait vers le joueur
 *  serait un missile déguisé et supprimerait l'anticipation au lieu de
 *  l'exiger.
 *
 *  ── La rotation par volée ──
 *  Les +9° d'`emitPhase` entre deux pulsations décalent les bras : deux spirales
 *  successives ne se recouvrent jamais, la fleur tourne au lieu de se figer en
 *  couloirs mémorisables. */
export default defineEnemy({
  id: 'tourbillon',
  rank: Rank.Standard,
  hp: 280,
  visualRadius: 32,
  score: 300,
  telegraph: 1.1,
  drops: 3,
  motion: { kind: Motion.Anchor, speed: 200, holdY: 330 },
  emitter: {
    pattern: Pattern.Spiral,
    every: 1.5,
    count: 10,
    // 300 u/s, dans la bande basse : la spirale doit rester longtemps en vol
    // pour que ses bras se lisent en train de s'enrouler. Trop rapide, l'arc se
    // détend et on ne voit plus qu'un anneau ordinaire.
    speed: 300,
    stepDeg: 9,
    // 85 °/s de courbe : assez pour que l'enroulement se voie à l'œil, assez peu
    // pour que le rayon de courbure reste large et l'esquive franche.
    turnDeg: 85,
    firstDelay: 1.7,
    family: Fam.EnemyPurple,
  },
});
